import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'smtp-email',
  version: '1.0.0',
  properties: [
    {
      key: 'credential',
      label: 'SMTP Credential',
      type: 'credential',
      required: true,
      credentialTypes: [
        { name: 'smtp', required: true },
        { name: 'test-smtp', required: true }
      ],
      description: 'SMTP server credentials (real or test)',
    },
    {
      key: 'from',
      label: 'From',
      type: 'string',
      required: true,
      placeholder: 'sender@example.com',
      description: 'Sender email address',
    },
    {
      key: 'to',
      label: 'To',
      type: 'string',
      required: true,
      placeholder: 'recipient@example.com',
      description: 'Recipient email address(es), comma-separated',
    },
    {
      key: 'cc',
      label: 'CC',
      type: 'string',
      default: '',
      placeholder: 'cc@example.com',
      description: 'CC email address(es), comma-separated',
    },
    {
      key: 'bcc',
      label: 'BCC',
      type: 'string',
      default: '',
      placeholder: 'bcc@example.com',
      description: 'BCC email address(es), comma-separated',
    },
    {
      key: 'subject',
      label: 'Subject',
      type: 'string',
      required: true,
      placeholder: 'Email subject',
      description: 'Email subject line',
    },
    {
      key: 'body',
      label: 'Body',
      type: 'text',
      required: true,
      placeholder: 'Email body content',
      description: 'Email body content',
      typeOptions: {
        rows: 10,
      },
    },
    {
      key: 'isHtml',
      label: 'HTML Email',
      type: 'boolean',
      default: false,
      description: 'Send email as HTML',
    },
    {
      key: 'attachments',
      label: 'Attachments',
      type: 'string',
      default: '',
      placeholder: 'Path to attachment data',
      description: 'Path to attachment data in input (e.g., data.attachments)',
    },
  ],
};

export default schema;
